$(document).on('ready turbolinks:load', function () {
  const $sidebar = $('#out-canvas-sidebar');
  const $openBtn = $('.open-offcanvas');
  const $overlay = $('.sidebar__offcanvas--overlay');
  // const $closeBtn = $('.close-offcanvas');
  
  $sidebar.sidebar();

  $sidebar.on("sidebar:opened", () => {
    $sidebar.addClass('opened')
  });
  $sidebar.on("sidebar:closed", () => {
    $sidebar.removeClass('opened')
  });

  $overlay.on('click', () => closeSidebar($sidebar))
  $openBtn.click(() => openSidebar($sidebar))
})

const openSidebar = ($sidebar) => $sidebar.trigger('sidebar:open')
const closeSidebar = ($sidebar) => $sidebar.trigger('sidebar:close')

